import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ItemStates } from '@site-mate/dashpivot-shared-library';

import { ListDeploymentService } from 'app/lists/list-deployment.service';
import { BannerKeys } from 'app/shared/model/banner-keys.enum';
import { BannerMetadata } from 'app/shared/model/banner-metadata.model';
import { UIComponentsTheme } from 'app/ui-components/ui-components-theme.enum';
import { UserService } from 'app/user/user.service';

@Component({
  selector: 'cc-list-tool-bar',
  templateUrl: './list-tool-bar.component.html',
  styleUrls: ['./list-tool-bar.component.scss', '../../../styles/components/tool-bar.component.scss'],
})
export class ListToolBarComponent {
  @Input() canDeployLists = false;
  @Input() selectedItemIds: string[] = [];
  @Output() readonly createNewItem = new EventEmitter<void>();
  @Output() readonly deleteSelectedItems = new EventEmitter<void>();
  @Output() readonly restoreSelectedItems = new EventEmitter<void>();
  @Output() readonly archiveSelectedItems = new EventEmitter<void>();
  readonly stateToggleTheme = UIComponentsTheme.Grey2;
  isInDeployMode = false;
  viewingListsInToggledState: ItemStates;
  itemStates = ItemStates;

  readonly archiveBannerKey = BannerKeys.ArchiveLists;
  readonly archiveBannerMetadata = BannerMetadata[this.archiveBannerKey];

  constructor(
    private readonly listDeploymentService: ListDeploymentService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly userService: UserService,
  ) {}

  isProjectControllerOrAbove$ = this.userService.isProjectControllerOrAbove$();

  ngOnInit(): void {
    this.viewingListsInToggledState = this.activatedRoute.snapshot.data.state;

    this.listDeploymentService.activeDeployMode$.subscribe((activeDeployMode) => {
      this.isInDeployMode = Boolean(activeDeployMode);
    });
  }

  startDeployMode() {
    this.listDeploymentService.startDeployMode(this.selectedItemIds);
    this.isInDeployMode = true;
  }

  startUndeployMode() {
    this.listDeploymentService.startUndeployMode(this.selectedItemIds);
  }
}
